// samplingSites/slice.js

import { samplingSitesInitialState } from "./samplingSitesState";
import { makeSamplingSitesActions } from "./samplingSitesActions";

export const createSamplingSitesSlice = (set, get) => ({
  samplingSites: samplingSitesInitialState,
  samplingSitesActions: Object.freeze(makeSamplingSitesActions(set, get)),
});
